import { render, staticRenderFns } from "./viewExpertTalks.vue?vue&type=template&id=06c245a9&"
import script from "./viewExpertTalks.vue?vue&type=script&lang=js&"
export * from "./viewExpertTalks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports